import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDoctorSpecializations } from "../../actions/userActions/doctorSpecializationAction";
import { Link, useHistory } from "react-router-dom";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton,Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import SearchInput from "../subComponents/search/SearchInput";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddDoctorSpecializations from "./AddDoctorSpecializations";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
import { Download } from 'lucide-react';
import { downloadDoctorSpecialization } from "../../actions/userActions/doctorSpecializationAction";


function DoctorSpecializations() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [expanded, setExpanded] = useState({});
  const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [doctorSpecializationData, setdoctorSpecializationData] = useState([]);

  const toggleExpansion = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    dispatch(getDoctorSpecializations());
  }, [dispatch]);

  const specializations = useSelector(
    (state) => state.doctor_specialization_reducer.specializations
  );

  const totalPages = specializations?.totalPages || 0;
  const totalItems = specializations?.totalCount || 0;
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  const isLoading = useSelector(
    (state) => state.doctor_specialization_reducer.isDoctorSpecializationLoading
  );

  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getDoctorSpecializations(pageNumber, itemsPerPage, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
 
  useEffect(() => {
    const SpecializationsData = specializations && specializations.result?.map((specializations) => ({
      ...specializations,
      status: (
        <span className={specializations.active ? "status-badge-active" : "status-badge-inactive"}>
          {specializations.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setdoctorSpecializationData(SpecializationsData);
  }, [specializations]);

  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    ];
  const handleEditDoctorSpecialization = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const actions = [  
    {
        label: 'Edit Doctor Specialization',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateDoctorSpecialization',
        handler:handleEditDoctorSpecialization,
    },
];

const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
};
const handleItemsPerPageChange = (value) => {
  const pageNumber = firstPage;
  dispatch(getDoctorSpecializations(pageNumber, value, query));
  setItemsPerPage(value);
  setCurrentPage(1);
};
const handleAddDoctorSpecializationClick = () => {
  setEditData(null);
  setShowModal(true);
};


const handleCloseModal = () => {
  setShowModal(false);
};

const handleSaveData = () => {
  dispatch(getDoctorSpecializations(currentPage, itemsPerPage, query));
  setShowModal(false);
};

const handleDoctorSpecializationDownload = () => {
  dispatch(downloadDoctorSpecialization());
};


  return (
    <>
      <LoadingOverlay isVisible={isLoading} />
     <div className="main-container">
            <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
              value={query}
                    />
                    <div className="flex-align-center">
                    <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                      <div style={{ paddingRight: '12px' }}>
                        <IconButton onClick={handleDoctorSpecializationDownload}>
                          <Download />
                        </IconButton>
                      </div>
                        {permissions && permissions.includes("CanAddDoctorSpecialization") && (
                            <CustomButton text={t("addNew")} onClick={handleAddDoctorSpecializationClick} />
                        )}
                    </div>
                </div>
               
            </div>
            <DynamicTable
                    data={ doctorSpecializationData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
            {showModal && (
        <AddDoctorSpecializations
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
        </div>
      
     
    </>
  );
}

export default DoctorSpecializations;
